"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var vue_1 = require("vue");
exports.Tag = vue_1.default.component('tag', {
    props: {
        tag: {
            type: String,
        },
        size: {
            type: String,
        },
        type: {
            type: String,
        },
    },
    methods: {
        getClasses: function () {
            var classes = ['tag-count'];
            classes.push("tag-" + this.tag);
            if (this.size !== undefined) {
                classes.push("tag-size-" + this.size);
            }
            if (this.type !== undefined) {
                classes.push("tag-type-" + this.type);
            }
            return classes.join(' ');
        },
    },
    template: '<div :class="getClasses()" />',
});
//# sourceMappingURL=Tag.js.map